import { createFormAction } from 'redux-form-saga'

import { SELECT_REQUEST, SELECT_SUCCESS, SELECT_FAILURE } from '../types/daily-reports'

const selectRequest = (data) => {
  return {
    payload: {
      data,
    },
    type: SELECT_REQUEST,
  }
}

const selectSuccess = (data) => {
  return {
    payload: {
      data,
    },
    type: SELECT_SUCCESS,
  }
}

const selectFailure = (exception) => {
  return {
    payload: {
      exception,
    },
    type: SELECT_FAILURE,
  }
}

const insert = createFormAction('DAILY_REPORTS_INSERT')
const update = createFormAction('DAILY_REPORTS_UPDATE')

export { selectRequest, selectSuccess, selectFailure, insert, update }
